import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import AppContext from '../../context/AppContext';

import Wrapper from './WrapperOLD';
import Button from '../../components/Button';
import { Input } from '../../components/Form';
import { TemplateField } from '../../components/Attributes/Attributes_old';

import useSearchParams from '../../hooks/useSearchParams';
import { useApp } from '../../context/AppContextBeta';

const SignIn = () => {
	const navigate = useNavigate();

	const { login, isLoggingIn, error } = useApp();
	const [formState, setFormState] = useState({});

	const { redirectTo } = useSearchParams();

	const handleSubmit = ({ email, password }) =>
		login({ email, password }, () => {
			navigate(redirectTo === null ? '/' : redirectTo);
		});
	const message = error ? { type: 'error', value: error.message } : null;

	return (
		<>
			<Wrapper title="Sign in" message={message}>
				<div className="space-y-6">
					<TemplateField
						name="Email address"
						onChange={(dataIndex, email) =>
							setFormState({ ...formState, email })
						}
					/>

					<div>
						<label
							htmlFor="password"
							className="block text-sm font-medium text-gray-700"
						>
							Password
						</label>
						<div className="mt-1">
							<Input
								id="password"
								name="password"
								type="password"
								autoComplete="current-password"
								className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
								placeholder="Password"
								onChange={(e) =>
									setFormState({ ...formState, password: e.target.value })
								}
								value={formState.password}
								onEnter={() => {
									handleSubmit(formState);
								}}
							/>
						</div>
					</div>

					<div className="flex items-center justify-end">
						<div className="text-xs">
							<a
								className="font-normal text-gray-400 hover:text-gray-500 cursor-pointer"
								onClick={() => navigate('/login/forgot')}
							>
								Forgot your password?
							</a>
						</div>
					</div>
					<div>
						<Button
							type="primary"
							className="flex w-full justify-center rounded-2xl border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
							onClick={() => handleSubmit(formState)}
						>
							{isLoggingIn ? 'Logging In...' : 'Sign In'}
						</Button>

						<Button
							type="secondary"
							className="rounded-2xl mt-3 text-gray-400 font-normal flex w-full justify-center hover:text-gray-500"
							onClick={() => navigate('/login/access')}
						>
							Sign in with Access Code
						</Button>
					</div>
				</div>
			</Wrapper>
		</>
	);
};

export default SignIn;
